module.exports = __webpack_public_path__ + "img/illustration-john-2.766c7e92.png";